import type { PlaybackPayload } from '@/features/watch/PlayerSurface';

import { supabase } from '@/lib/supabase';

// Owner-preview playback token (Spec 20). Creators view their own not-yet-
// published video through the same signed-embed function as the member gate,
// intent: 'preview' — the server authorizes by content/upload ownership (or
// admin) and never touches the freemium ledger. Returns null on any denial.
export async function fetchPreviewPlayback(
  body: { contentId: string } | { uploadId: string },
): Promise<PlaybackPayload | null> {
  const { data, error } = await supabase.functions.invoke('video-playback-token', {
    body: { ...body, intent: 'preview' },
  });
  if (error) return null;
  const payload = data as { allowed?: boolean; playback?: PlaybackPayload } | null;
  return payload?.allowed && payload.playback ? payload.playback : null;
}
